import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';

import { ContingentSubscription } from '@vi-iot/client';

import { BOOKING_PARAMS, BookingStore, ContingentSubscriptionsQueryParams } from '@store';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-booking-contingent-subscription-details',
  templateUrl: './booking-contingent-subscription-details.component.html',
  styleUrls: ['./booking-contingent-subscription-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingContingentSubscriptionDetailsComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  contingentSubscriptionValidDate: string;

  @Input() contingentSubscription: ContingentSubscription;

  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private bookingStore: BookingStore
  ) {}

  ngOnInit(): void {
    this.setValidDateOfContingentSubscription(this.contingentSubscription.invoiceDate);
  }

  onActivateVoucher(): void {
    this.bookingStore.loadBookingInstallation();
    let queryParams: ContingentSubscriptionsQueryParams = {
      [BOOKING_PARAMS.INVOICE_NUMBER]: this.contingentSubscription.invoice,
    };

    this.router.navigate(['/booking'], {
      queryParams,
    });
  }

  private setValidDateOfContingentSubscription(invoiceDate: Date): void {
    const validDate = moment(invoiceDate).add(1, 'y').subtract(1, 'days');

    this.contingentSubscriptionValidDate = this.datePipe.transform(moment(validDate).toDate());
  }
}
